import {
  Box,
  BoxProps,
  styled,
  Typography,
  type TypographyProps
} from '@mui/material';

export const StyledOptionBox = styled(Box)<BoxProps>(({ theme }) => ({
  width: '100%',
  paddingTop: theme.spacing(0.5),
  paddingBottom: theme.spacing(0.5)
}));

export const StyledOptionRow = styled(Box)<BoxProps>(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'baseline'
}));

export const StyledEmployeeNameTypography = styled(Typography)<TypographyProps>(
  () => ({
    flexShrink: 1
  })
);

export const StyledSecondaryTypography = styled(Typography)<TypographyProps>(
  ({ theme }) => ({
    flexShrink: 0,
    marginLeft: theme.spacing(1)
  })
);
